import React from 'react';
import Select, { StylesConfig } from 'react-select';
import { ISelectOption } from '../ISelectOption';
import { IRole } from '../../../utils/types/IRole';

interface RoleSelectProps {
    roles: IRole[];
    isRolesLoading: boolean;
    setSelectedRoleId: (id: string | null) => void;
    selectedRoleId: string | null;
}

const customStyles: StylesConfig<ISelectOption, false> = {
    control: (provided) => ({
        ...provided,
        width: 'auto',
        minWidth: '150px',
        maxWidth: '100%',
    }),
    singleValue: (provided) => ({
        ...provided,
        whiteSpace: 'nowrap',
    }),
    menu: (provided) => ({
        ...provided,
        width: 'auto',
        minWidth: '150px',
    }),
    option: (provided) => ({
        ...provided,
        whiteSpace: 'nowrap',
    }),
    menuPortal: (provided) => ({
        ...provided,
        zIndex: 9999,
    }),
};

const RoleSelect: React.FC<RoleSelectProps> = ({ roles, isRolesLoading, setSelectedRoleId, selectedRoleId }) => {
    const options: ISelectOption[] = roles.map((role) => ({
        value: role.id.toString(),
        label: role.normalizedName ?? '-',
    }));

    const selectedOption = options.find((option) => option.value === selectedRoleId) || null;

    const handleChange = (selectedOption: ISelectOption | null) => {
        setSelectedRoleId(selectedOption ? selectedOption.value : null);
    };

    return <Select id="autoSizingSelect" value={selectedOption} options={options} onChange={handleChange} placeholder={isRolesLoading ? 'Chargement ...' : '--- Rôle'} isLoading={isRolesLoading} isClearable isSearchable noOptionsMessage={() => 'Aucun rôle'} styles={customStyles} classNamePrefix="react-select" menuPortalTarget={document.body} />;
};

export default RoleSelect;
